import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { usePlaidLink } from "react-plaid-link";

import { createPlaidLink } from "features/SurmountAccount/service";
import { toggleUnsupportedBankModal } from "Layout/slice";

// Plaid can't hide a bank from its own search, so we turn it away instead.
// Also enforced server-side in plaid_institution_policy.py — keep both in sync.
const BLOCKED_INSTITUTION_PATTERN = /robinhood/i;

export const usePlaid = ({ active = false, successCallback, exitCallback }) => {
  const dispatch = useDispatch();
  const [plaidConfig, setPlaidConfig] = useState({
    token: "",
  });

  const { ready, open } = usePlaidLink(plaidConfig);

  useEffect(() => {
    if (!active) {
      return;
    }

    (async () => {
      try {
        const response = await createPlaidLink();
        setPlaidConfig({
          ...plaidConfig,
          token: response.link_token,
          onSuccess,
          onExit,
        });
      } catch (error) {
        console.error("error: ", error);
      }
    })();
  }, [active]);

  const onSuccess = useCallback(
    async (public_token, metadata) => {
      try {
        // Turned away before the token reaches the backend.
        if (
          BLOCKED_INSTITUTION_PATTERN.test(metadata?.institution?.name || "")
        ) {
          dispatch(toggleUnsupportedBankModal(true));
          if (exitCallback) exitCallback();
          return;
        }

        successCallback(public_token, metadata);
      } catch (error) {
        console.error("error: ", error);
      }
    },
    [plaidConfig.token]
  );

  const onExit = useCallback(
    (err) => {
      if (exitCallback) exitCallback();
      if (err) console.error("Plaid Err: ", err);
    },
    [plaidConfig.token]
  );

  return { ready, open };
};
